module.exports = __webpack_public_path__ + "static/media/6.00a8efa7.jpeg";